import {
	OfferActionField,
	OfferCompatibleWithField,
	OfferConditionField,
	OfferField,
	OfferGroupField,
	OfferMappingField,
	OfferRuleField,
	OfferTermsBlockField,
	RuleOperator,
} from "../constants";

/** Creates one blank rule condition row for the form. */
export const createEmptyCondition = () => ({
	[OfferConditionField.SUBJECT]: "",
	[OfferConditionField.OPERATOR]: "",
	[OfferConditionField.VALUE]: "",
	[OfferConditionField.VALUE_LABEL]: "",
});

/** Creates one blank terms block for the form. */
export const createEmptyTermsBlock = () => ({
	[OfferTermsBlockField.TYPE]: "",
	[OfferTermsBlockField.CONTENT]: "",
});

/** Builds the empty draft used when Create Offer opens. */
export const createInitialOfferDraft = () => ({
	[OfferField.TITLE]: "",
	[OfferField.OFFER_CODE]: "",
	[OfferField.DESCRIPTION]: "",
	[OfferField.OFFER_TYPE]: "",
	[OfferField.SUB_OFFER_TYPE]: "",
	[OfferField.OFFER_GROUP_ID]: "",
	[OfferField.PRIORITY]: "",
	[OfferField.CHANNEL]: "",
	[OfferField.START_DATE]: null,
	[OfferField.END_DATE]: null,
	[OfferField.MAX_USAGE_COUNT]: "",
	[OfferField.INDIVIDUAL_MAX_USAGE_COUNT]: "",
	[OfferField.USAGE_COUNT]: 0,
	[OfferField.VERSION]: "1.0.0",
	[OfferField.RULE]: {
		[OfferRuleField.DESCRIPTION]: "",
		[OfferRuleField.OPERATOR]: RuleOperator.AND,
		[OfferRuleField.CONDITIONS]: [createEmptyCondition()],
		[OfferRuleField.ACTION]: {
			[OfferActionField.TYPE]: "",
			[OfferActionField.VALUE]: "",
			[OfferActionField.TARGET]: "",
			[OfferActionField.MIN_AMOUNT_LIMIT]: "",
			[OfferActionField.MAX_AMOUNT_LIMIT]: "",
		},
	},
	[OfferField.OFFER_MAPPING]: {
		[OfferMappingField.MENU_IDS]: [],
		[OfferMappingField.RESTAURANT_IDS]: [],
		[OfferMappingField.USER_IDS]: [],
	},
	[OfferField.MENU_LABELS]: {},
	[OfferField.TERMS_CONDITION]: [],
});

/** Builds the empty draft used when Create Offer Group opens. */
export const createInitialOfferGroupDraft = () => ({
	[OfferGroupField.NAME]: "",
	[OfferGroupField.CAN_APPLY_MULTIPLE_OFFERS]: false,
	[OfferGroupField.COMPATIBLE_WITH]: {
		[OfferCompatibleWithField.INCLUDES]: [],
		[OfferCompatibleWithField.EXCLUDES]: [],
	},
});

/** Deep-clones plain objects/arrays while keeping Date instances intact. */
const deepClonePreservingDates = (value) => {
	if (value === null || typeof value !== "object") return value;
	if (value instanceof Date) return new Date(value.getTime());
	if (Array.isArray(value)) return value.map(deepClonePreservingDates);
	const cloned = {};
	Object.keys(value).forEach((key) => {
		cloned[key] = deepClonePreservingDates(value[key]);
	});
	return cloned;
};

/** Deep-clones an offer draft, preserving Date objects for edit baselines. */
export const cloneOfferDraft = (draft) => {
	if (!draft) return null;
	if (typeof window.structuredClone === "function") {
		return window.structuredClone(draft);
	}
	return deepClonePreservingDates(draft);
};